import { useState } from 'react'

export const useCustomInput = () => {
  const [isFocus, setIsFocus] = useState<boolean>(false)

  const handleFocus = () => {
    setIsFocus(true)
  }

  const handleBlur = () => {
    setIsFocus(false)
  }

  return { isFocus, setIsFocus, handleFocus, handleBlur }
}
